
/**
 * @fileoverview This file contains all the necessary scripts for the URL path 'phone/###/##'.
 * If a script is not used on these pages, please consider adding it to the correct file.
 */
import $ from 'jquery';

import 'jquery-validation';
import 'jquery-mask-plugin';
import 'jquery-smooth-scroll';

window.jQuery = $;
window.$ = $;

import * as commonJS from './common.js';
import * as account from './account.js';

// This export is important to ensure webpack detects the JS and does not skip it during cleaning
export { commonJS, account};